import { format } from 'rut.js';

const formatWithoutDots = (rut: string) => {
  return format(rut).replace(/\./g, '');
};

const formatWithDots = (rut: string) => {
  return format(rut);
};

const RutTools = {
  formatWithoutDots,
  formatWithDots,
};

export default RutTools;
